<template>
  <div class="home">
    <carousel_panel />
    <node_construction />
    <identity_query />
    <!-- <platform_data /> -->
    <login_box />
    <the_solution />
    <app_store />
    <!-- <exchange_market /> -->
    <!-- <s_d_matching /> -->
    <!-- <expert_database /> -->
    <!-- <training_module /> -->
    <policy_declaration />
    <!-- <financial_service /> -->
    <news_list />
  </div>
</template>

<script>
import carousel_panel from "./components/carousel_panel/index.vue";
import identity_query from "./components/identity_query/index.vue";
import node_construction from "./components/node_construction/index.vue";
// import platform_data from "./components/platform_data/index.vue";
import login_box from "./components/login_box/index.vue";
import the_solution from "./components/the_solution/index.vue";
import app_store from "./components/app_store/index.vue";
// import exchange_market from "./components/exchange_market/index.vue";
// import s_d_matching from "./components/s_d_matching/index.vue";
// import expert_database from "./components/expert_database/index.vue";
// import training_module from "./components/training_module/index.vue";
import policy_declaration from "./components/policy_declaration/index.vue";
// import financial_service from "./components/financial_service/index.vue";
import news_list from "./components/news_list/index.vue";

export default {
  name: "Home",
  components: {
    carousel_panel,
    identity_query,
    node_construction,
    // platform_data,
    login_box,
    the_solution,
    app_store,
    // exchange_market,
    // s_d_matching,
    // expert_database,
    // training_module,
    policy_declaration,
    // financial_service,
    news_list,
  },
  data() {
    return {};
  },
  mounted() {
    new this.$wow.WOW({
      boxClass: "wow",
      offset: 0,
      live: false,
    }).init();
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
